import {IntermediatePart} from "../../intermediatePart";
import {Vanity} from "../../parts/vanity";
import {createParentPositions} from "../../constants";

export default class DrawerHandle extends IntermediatePart {

  constructor(isChild) {
    super(isChild);
    this.partId = 'drawer_handle';
    this.partName = 'Drawer Handle';
    this.translateId = "visualizer.kitchen.cabinet.drawer_handle";
    this.visible = [Vanity.Types.Custom];
    this.canBeDisabled = false;
    if (isChild) {
      createParentPositions(this);
    }
  }

  disabledClick() {
    this.getParent().toggleVanityParts(this.disabled);
  }

  getArrayOfConditions() {
    const conditions = super.getArrayOfConditions();
    const vanityParent = this.getParent();
    conditions.push({
      propName: "VanitySize",
      propValue: vanityParent.counterTopSize(this)
    })
    return conditions
  }
}
